import React from 'react';

import {
	BrandHeading,
	type GroupData,
	type IconCardData,
	IconCardGroup,
} from '@af/design-system-docs-ui';
import { Stack, Text } from '@atlaskit/primitives';

import OverviewPage from '../../../templates/overview-page';
import heroDark from './_assets/hero.dark.png';
import heroLight from './_assets/hero.light.png';

const data: GroupData<IconCardData>[] = [
	{
		title: 'Content guidelines',
		cards: [
			{
				title: 'Inclusive language',
				description:
					'Learn how to create inclusive content and app experiences using inclusive design principles and techniques.',
				href: '/foundations/content/inclusive-writing',
			},
			{
				title: 'Style, grammar, and punctuation',
				description:
					'Follow these writing conventions to make your apps and experiences clear, consistent, and localizable.',
				href: '/foundations/content/language-and-grammar',
			},
			{
				title: 'Voice and tone',
				description: 'Create UI and app content that aligns with Atlassian’s voice and tone.',
				href: '/foundations/content/voice-tone',
			},
			{
				title: 'Date and time',
				description:
					'Communicate date and time clearly and consistently to align to wherever our customers are located.',
				href: '/foundations/content/date-time',
			},
			{
				title: 'Designing messages',
				description:
					'Learn how to write and format success and error messages and other types of alerts.',
				href: '/foundations/content/designing-messages',
			},
		],
	},
];

export default (): React.JSX.Element => {
	return (
		<OverviewPage
			categorySlug="content"
			title="Content"
			description="Use our content foundations to ensure clear, concise, and consistent language throughout our apps."
			image={{
				light: heroLight,
				dark: heroDark,
			}}
			entries={data}
		>
			<Stack space="space.800">
				<Stack space="space.200">
					<BrandHeading as="h2" size="large">
						Content guidelines
					</BrandHeading>
					<Stack space="space.100">
						<Text as="p">
							Content is at the heart of quality interfaces and apps. Use these guidelines to help
							you write clear and consistent UI content.
						</Text>
					</Stack>
				</Stack>
				<IconCardGroup data={data} />
			</Stack>
		</OverviewPage>
	);
};
